import { ElementaryZone } from "@/models/site.model";
import { ValidationRule } from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";

export class Validators {
  public static hasPersonnelDecontamination(elementaryZones: ElementaryZone[]): boolean {
    const numberOfPersonnelDecontaminationZones = elementaryZones.filter(
      (e) => e.personnelDecontamination
    ).length;
    return numberOfPersonnelDecontaminationZones > 0 && numberOfPersonnelDecontaminationZones <= 2;
  }

  public static hasWasteDecontamination(elementaryZones: ElementaryZone[]): boolean {
    const numberOfWasteDecontaminationZones = elementaryZones.filter(
      (e) => e.wasteDecontamination
    ).length;
    return numberOfWasteDecontaminationZones > 0 && numberOfWasteDecontaminationZones <= 2;
  }

  public static elementaryZonesHaveUniqueNames(elementaryZones: ElementaryZone[]): boolean {
    //Using set feature to have only unique objets we are testing if names are unique.
    const uniqueNameSet = new Set(elementaryZones.map((zone) => zone.name.toLowerCase()));

    //If all zone have a different name no object should be deleted and length should stay equal.
    return uniqueNameSet.size === elementaryZones.length;
  }

  public static hasExtractors(elementaryZones: ElementaryZone[]): boolean {
    const numberOfExtractors = elementaryZones.filter((e) => e.extractorsInstallation).length;
    return numberOfExtractors > 0;
  }

  public static regex(exp: RegExp): ValidationRule {
    return helpers.regex("regex", exp);
  }
}
